export function normalizeApiArray<T>(response: unknown): T[] {
  if (!response) {
    return [];
  }

  if (Array.isArray(response)) {
    return response as T[];
  }

  if (typeof response !== 'object') {
    return [];
  }

  const candidate = response as {
    $values?: unknown;
    data?: unknown;
    result?: unknown;
    items?: unknown;
  };

  if (Array.isArray(candidate.$values)) {
    return candidate.$values as T[];
  }

  if (candidate.data) {
    return normalizeApiArray<T>(candidate.data);
  }

  if (candidate.result) {
    return normalizeApiArray<T>(candidate.result);
  }

  if (candidate.items) {
    return normalizeApiArray<T>(candidate.items);
  }

  return [response as T];
}

export function getLatestByDate<T>(
  items: T[],
  getDate: (item: T) => string | number | Date | null | undefined
): T | null {
  if (!items.length) {
    return null;
  }

  return [...items].sort((first, second) => {
    const firstDate = new Date(getDate(first) || 0).getTime();
    const secondDate = new Date(getDate(second) || 0).getTime();
    return secondDate - firstDate;
  })[0];
}
